import moment from 'moment'

/** Person date fields EPS accepts as YYYY-MM-DD (both casings). */
export const PERSON_DATE_FIELD_NAMES = new Set([
  'DateOfBirth',
  'dateOfBirth',
  'HireDate',
  'hireDate',
  'OriginalHireDate',
  'originalHireDate',
  'MarriageDate',
  'marriageDate',
  'DriverLicenseExpirationDate',
  'driverLicenseExpirationDate',
  'BenefitsEffectiveDate',
  'benefitsEffectiveDate',
  'EnrollmentStartDate',
  'enrollmentStartDate',
  'EnrollmentEndDate',
  'enrollmentEndDate',
])

export function formatDateForForm(value) {
  if (value == null || value === '') {
    return value
  }

  if (typeof value === 'string' && /^\d{4}-\d{2}-\d{2}T/.test(value)) {
    return moment(value.slice(0, 10), 'YYYY-MM-DD', true).format('MM/DD/YYYY')
  }

  const strictParsed = moment(value, ['MM/DD/YYYY', 'M/D/YYYY', 'YYYY-MM-DD'], true)
  if (strictParsed.isValid()) {
    return strictParsed.format('MM/DD/YYYY')
  }

  return value
}

export function formatDateForEps(value) {
  if (value == null || value === '') {
    return value
  }

  if (value instanceof Date) {
    return moment(value).format('YYYY-MM-DD')
  }

  if (typeof value === 'string') {
    if (/^\d{4}-\d{2}-\d{2}$/.test(value)) {
      return value
    }

    if (/^\d{4}-\d{2}-\d{2}T/.test(value)) {
      return value.slice(0, 10)
    }
  }

  const strictParsed = moment(value, ['MM/DD/YYYY', 'M/D/YYYY', 'YYYY-MM-DD'], true)
  if (strictParsed.isValid()) {
    return strictParsed.format('YYYY-MM-DD')
  }

  const relaxedParsed = moment(value)
  if (relaxedParsed.isValid()) {
    return relaxedParsed.format('YYYY-MM-DD')
  }

  return value
}

export function formatPersonDateFieldsForEps(person) {
  if (!person || typeof person !== 'object') {
    return person
  }

  return Object.fromEntries(
    Object.entries(person).map(([key, value]) => [
      key,
      PERSON_DATE_FIELD_NAMES.has(key) && value != null && value !== ''
        ? formatDateForEps(value)
        : value,
    ])
  )
}
